import React, { useState } from "react";

const Glossary = () => {
  const [activeTab, setActiveTab] = useState("A");

  const glossaryData = {
    A: [
      {
        term: "Alienação de Bens",
        description:
          "Representa a entrada de recursos provenientes da venda de bens móveis e imóveis.",
      },
      {
        term: "Amortização da Dívida",
        description:
          "Despesas com o pagamento do principal e atualização monetária dos empréstimos realizados.",
      },
      {
        term: "Amortização de Empréstimos",
        description:
          "Representa a entrada de recursos provenientes da amortização, ou seja, parcelas recebidas de empréstimos concedidos.",
      },
    ],
    B: [
      {
        term: "Balanço",
        description:
          "Demonstrativo que apresenta a situação orçamentária, financeira e patrimonial da entidade pública.",
      },
      {
        term: "Bem de Capital",
        description:
          "São bens duráveis com vida útil superior a 2 anos, como máquinas, instalações, móveis, etc.",
      },
    ],
    C: [
      {
        term: "Concorrência",
        description:
          "Modalidade de licitação entre quaisquer interessados que comprovem requisitos mínimos.",
      },
      {
        term: "Contrato",
        description: "Acordo ou ajuste entre partes com interesses diversos.",
      },
      {
        term: "Contribuições",
        description: "Porção cuja origem pode ser atribuída a alguém ou algo.",
      },
      {
        term: "Convênio",
        description:
          "Instrumento que disciplina compromissos entre dois ou mais participantes com objetivo comum.",
      },
      {
        term: "Convite",
        description:
          "Modalidade de licitação entre interessados escolhidos e convidados pela unidade administrativa.",
      },
      {
        term: "CPL",
        description:
          "Órgão vinculado ao Chefe do Poder Executivo, responsável por licitações e funções administrativas.",
      },
    ],
    D: [
      {
        term: "Dedução para a Formação do FUNDEB",
        description:
          "Corresponde a 20% da arrecadação de tributos que é destinado ao FUNDEB.",
      },
      {
        term: "Despesas Correntes",
        description:
          "Despesas contínuas ligadas à manutenção da máquina administrativa.",
      },
      {
        term: "Despesas de Capital",
        description:
          "Despesas de caráter duradouro, como construção de escolas e compra de equipamentos.",
      },
      {
        term: "Diária",
        description: "Ração, receita, salário ou renda de cada dia.",
      },
      {
        term: "Dispensa",
        description:
          "Anulação de um acordo ou contrato de trabalho feita pelo contratante.",
      },
    ],
    // Letras não fornecidas retornam um texto padrão
    E: [
      {
        term: "Empenho",
        description: "Ato que cria obrigação de pagamento pendente.",
      },
    ],
    F: [
      {
        term: "Função de Governo",
        description: "Área de atuação onde o governo aplica recursos.",
      },
    ],
    G: [
      {
        term: "Garantias e Contragarantias de Valores",
        description:
          "Valores oferecidos para garantir obrigações financeiras contraídas por entes da Federação.",
      },
    ],
    I: [
      {
        term: "Inversões Financeiras",
        description:
          "Despesas com a aquisição de imóveis ou bens de capital que já estejam em utilização.",
      },
      {
        term: "Investimentos",
        description: "Despesas com planejamento e execução de obras.",
      },
    ],
    J: [
      {
        term: "Juros e Encargos da Dívida",
        description:
          "Despesas com o pagamento de juros e encargos referentes a empréstimos realizados.",
      },
    ],
    L: [
      {
        term: "LDO",
        description:
          "Lei de Diretrizes Orçamentárias. Define metas e prioridades.",
      },
      {
        term: "Licitação",
        description:
          "Processo de aquisição de bens e serviços pelo poder público.",
      },
      {
        term: "Liquidação",
        description: "Verificação do direito adquirido pelo credor.",
      },
      {
        term: "LOA",
        description:
          "Lei Orçamentária Anual que prevê receitas e despesas do governo.",
      },
    ],
    O: [
      {
        term: "Operações de Crédito",
        description: "Contratação de empréstimos e financiamentos.",
      },
      {
        term: "Organograma",
        description: "Representação gráfica da hierarquia de uma organização.",
      },
    ],
    P: [
      {
        term: "PPA",
        description:
          "Plano Plurianual. Define objetivos e metas do governo para o período de 4 anos.",
      },
    ],
    R: [
      {
        term: "Receita Corrente",
        description: "Ingressos que aumentam o patrimônio não duradouro.",
      },
    ],
    T: [
      {
        term: "Tomada de Preços",
        description:
          "Modalidade de licitação para interessados previamente cadastrados com qualificação necessária.",
      },
    ],
  };

  const renderContent = () => {
    const content = glossaryData[activeTab] || [
      { term: "Não existe glossário para essa letra.", description: "" },
    ];
    return content.map((item, index) => (
      <div key={index} className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800">{item.term}</h3>
        <p className="text-gray-600">{item.description}</p>
      </div>
    ));
  };

  return (
    <div className="grid grid-cols-[auto_1fr] gap-4">
      {/* Letras em Vertical com Rolagem */}
      <div
        className="overflow-y-scroll border-r pr-2"
        style={{ maxHeight: "60vh" }}
      >
        {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((letter) => (
          <button
            key={letter}
            onClick={() => setActiveTab(letter)}
            className={`block py-2 px-2 text-center font-semibold focus:outline-none ${
              activeTab === letter
                ? "text-blue-500 font-bold"
                : "text-gray-700 hover:text-blue-500"
            }`}
          >
            {letter}
          </button>
        ))}
      </div>

      {/* Conteúdo do Glossário */}
      <div
        className="p-4 border rounded-lg overflow-y-auto"
        style={{ maxHeight: "60vh" }}
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Glossário</h2>
        {renderContent()}
      </div>
    </div>
  );
};

export default Glossary;
